import "./css/bootstrap.min.css";
import "./css/dashboard.css";
import "./css/site.css";

import React from "react";
import axios from "axios";
import * as ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { createBrowserHistory } from "history";
import configureStore from "./configureStore";
import * as RoutesModule from "./routes";
import { rootSaga } from "./sagas";
import ExEnv from "exenv";
import ReduxToastr from "react-redux-toastr";
import Immutable from "seamless-immutable";
import { default as HttpInterceptors } from "./utils/http-interceptors";
import { createUserManager, loadUser, OidcProvider } from "redux-oidc";
import { OidcConfiguration } from "./configs/oidc";

import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

let routes = RoutesModule.routes;

const isDeveloping = process.env.NODE_ENV !== "production";
const restUri = window.location.hostname.split(".").slice(1).join(".");
const uriPort = isDeveloping ? "8101" : window.location.port;
const uriName = window.location.hostname.split(".")[0];

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const baseApiUrl = `https://${uriName}-api.${restUri}:${uriPort}`;

const userManager = createUserManager(OidcConfiguration);
const history = createBrowserHistory({ basename: baseUrl });

axios.defaults.baseURL = baseApiUrl;

const stableServerIdentity = (window.initialReduxState &&
  window.initialReduxState.serverIdentity) || { authority: "", client_id: "" };
const initialState = Immutable({
  ...window.initialReduxState,
  serverIdentity: stableServerIdentity,
});
const store = configureStore(history, initialState);
store.runSaga(rootSaga);

HttpInterceptors.setup(store, history);
function renderApp(store, routes, history) {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <OidcProvider {...{ store, userManager }}>
          <div>
            <ConnectedRouter children={routes} history={history} />
            {ExEnv.canUseDOM ? <ReduxToastr /> : null}
          </div>
        </OidcProvider>
      </Provider>
    </AppContainer>,
    document.getElementById("root"),
  );
}

renderApp(store, routes, history);
loadUser(store, userManager);
// Allow Hot Module Replacement
if (module.hot) {
  module.hot.accept("./routes", () => {
    routes = require("./routes").routes;
    renderApp(store, routes, history);
  });
}
